import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chart-ppf', 'ChartPpf', [["path",{"d":"M19 17c0 -6.075 -5.373 -11 -12 -11"}],["path",{"d":"M3 3v18h18"}]]);